import Vue from 'vue'
let requests = []
let reqId = 0
export default {
  getAnalyticsData({getters, commit}, params) {
    const workspace = getters.workspace
    const existedData = getters.analyticsData[params.periodIndex]
    if(params.calc_object === 'territory'
      && existedData
      && existedData[params.columnType]
      && existedData[params.columnType][params.columnSubType || '-']
      && existedData[params.columnType][params.columnSubType || '-'][params.territoryId]) {
      return Promise.resolve()
    } else if((params.calc_object === 'period' || params.calc_object === 'season')
      && getters.analyticsChart[params.calc_object]
      && getters.analyticsChart[params.calc_object][params.columnType]
      && getters.analyticsChart[params.calc_object][params.columnType][params.columnSubType || '-']
      && getters.analyticsChart[params.calc_object][params.columnType][params.columnSubType || '-'][params.territoryId]) {
      return Promise.resolve()
    } else {
      const currentReqId = reqId++

      return Vue.http.get(getters.endpoint.analytics, {
        params: {
          workspace: workspace,
          version: getters.version,
          type_separation: params.territoryType,
          separation: params.separation || null,
          param: params.columnType,
          periodId: params.periodId ? params.periodId.join(',') : null,
          seasonId: params.seasonId ? params.seasonId.join(',') : null,
          calc_object: params.calc_object,
          slice: params.columnSubType || null
        },
        before(request) {
          let requestsToAbort = []
          if(request.params.calc_object === 'period') {
            requestsToAbort = requests.filter(v => v.request.params.calc_object === 'period') || []
          } else {
            requestsToAbort = requests.filter(v => {
              return (v.request.params.calc_object === request.params.calc_object)
                && ((v.request.params.periodId !== request.params.periodId)
                  || (v.request.params.seasonId !== request.params.seasonId)
                  || v.request.params.type_separation !== request.params.type_separation
                  || (v.request.params.separation !== request.params.separation))
            }) || []
          }
          console.log('to abort: ',requestsToAbort)
          requestsToAbort.forEach(v => v.request.abort())
          requests.push({
            id: currentReqId,
            request
          })
        }
      }).then(r => {
        requests = requests.filter(v => v.id !== currentReqId)
        if(params.calc_object === 'territory') {
          const valuesMap = {}
          r.body.values.forEach(v => {
            valuesMap[v.id] = v.value ? v.value.represent || '' : '-'
          })
          const datas = {
            [params.periodIndex]: {
              [params.columnType]: {
                [params.columnSubType || '-']: {
                  [params.territoryId]: {
                    sum: r.body.sum,
                    values: valuesMap
                  }
                }
              }
            }
          }
          commit('setAnalyticsData', datas)
        }
        if(params.calc_object === 'period' || params.calc_object === 'season') {
          const chartData = {}
          r.body.values.forEach(v => {
            chartData[v.id] = v.value.val.toFixed(1)
          })
          commit('setAnalyticsChart', {
            [params.calc_object]: {
              [params.columnType]: {
                [params.columnSubType || '-']: {
                  [params.territoryId]: chartData
                }
              }
            }
          })
        }
      }).catch(e => {
        requests = requests.filter(v => v.id !== currentReqId)
        console.log(e)
        if(e.status === 0) {
          return
        }
        if(params.calc_object === 'territory') {
          commit('setAnalyticsData', {
            [params.periodIndex]: {
              [params.columnType]: {
                [params.columnSubType || '-']: {
                  [params.territoryId]: {
                    error: true
                  }
                }
              }
            }
          })
        } else {
          commit('setAnalyticsChart', {
            [params.calc_object]: {
              [params.columnType]: {
                [params.columnSubType || '-']: {
                  [params.territoryId]: {
                    error: true
                  }
                }
              }
            }
          })
        }
      })
    }
  },
  getAnalyticsColumnSubTypes({getters, commit}) {
    return Vue.http.get(getters.endpoint.analyticSlices, {
      params: {
        workspace: getters.workspace,
        version: getters.version,
      }
    }).then(r => {
      commit('setAnalyticsColumnSubTypes', r.body)
    })
  },
  clearAnalyticsStore({commit}) {
    commit('clearAnalytics')
  },
  clearFullAnalyticsStore({commit}) {
    commit('clearFullAnalytics')
  }
}



// WEBPACK FOOTER //
// ./src/store/analytics/actions.js